import { render } from "./OrderCompleteComponent.vue?vue&type=template&id=2ded8add"
import script from "./OrderCompleteComponent.vue?vue&type=script&lang=js"
export * from "./OrderCompleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__